<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import Vue from 'vue';
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);
export default {};
</script>

<style lang="less"></style>
